export default __webpack_public_path__ + "static/media/graphsPreview@2x.3c3f72bb.png";